// ----------------------------------------------------------------------------
// Optional Feature: Sticky Header
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import $ from 'jquery';


// -------------------------------------
// Hooks
// -------------------------------------
const HEADER_SECTION = ".shopify-section--header";

const scrollUp = "scroll-up";
const scrollDown = "scroll-down";
let lastScroll = 0;

// Stick the header when scrolling past the top
window.addEventListener('scroll', () => {
    const headerSection = document.querySelector(HEADER_SECTION);
    const currentScroll = window.scrollY;

    if (currentScroll <= 30) {
        headerSection.classList.remove(scrollDown);
        headerSection.classList.remove(scrollUp);
        return;
    }
    
    if (currentScroll > (lastScroll + 30)) {
        //down
        headerSection.classList.remove(scrollUp);
        headerSection.classList.add(scrollDown);
    } else if (currentScroll < (lastScroll - 30)) {
        //up
        headerSection.classList.remove(scrollDown);
        headerSection.classList.add(scrollUp);
    }

    lastScroll = currentScroll;
});
